var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _circle, _path16, _path17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBridgingLoan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 61V49L6 61h7z",
    fill: "#E1F8F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.65 51.192v1.9m8.107-3.8v12.16H4.65V56.5",
    stroke: "#376E66",
    strokeWidth: 1.922,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.346 49.39a.96.96 0 111.922 0h-1.922zM12.792 61.431v.961a.961.961 0 01-.96-.96h.96zm-.96-12.04a.961.961 0 111.921 0h-1.922zm17.475 12.04h.96c0 .531-.43.961-.96.961v-.96zm-17.476 0v-12.04h1.922v12.04h-1.922zm18.437-12.04v12.04h-1.922v-12.04h1.922zm-.961 13.001H12.792V60.47h16.515v1.922z",
    fill: "#376E66"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.432 38.854h8.678l-11.432 8.834H2l11.432-8.834z",
    stroke: "#376E66",
    strokeWidth: 1.922,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.757 38.144a.96.96 0 10-1.295 1.42l1.295-1.42zm7.929 9.832a.961.961 0 001.295-1.42l-1.295 1.42zm-9.224-8.412l9.224 8.412 1.295-1.42-9.224-8.412-1.295 1.42z",
    fill: "#376E66"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#376E66",
    strokeWidth: 1.922,
    strokeLinejoin: "round",
    d: "M19.565 47.885h4.515v6.021h-4.515z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M49 61V48l-6 13h6zM74 58V45l-6 13h6z",
    fill: "#E1F8F1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M41.317 50.459v10.26h8.107v-12.16",
    stroke: "#376E66",
    strokeWidth: 1.922,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M65.013 48.657a.96.96 0 111.922 0h-1.922zM49.459 60.698v.961a.96.96 0 01-.96-.96h.96zm-.96-12.041a.96.96 0 011.921 0h-1.922zm17.475 12.041h.96c0 .53-.43.961-.96.961v-.96zm-17.476 0V48.657h1.922v12.041h-1.922zm18.437-12.041v12.041h-1.922V48.657h1.922zm-.961 13.002H49.459v-1.922h16.515v1.922z",
    fill: "#376E66"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5 59.002a.96.96 0 010-1.922v1.922zm5.015-.96h.96a.96.96 0 01-.96.96v-.96zM72.554 36.5a.961.961 0 111.922 0h-1.922zm0 8a.961.961 0 111.922 0h-1.922zm1.922-3a.961.961 0 11-1.922 0h1.922zm-.961 17.502H68.5V57.08h5.015v1.922zm.96-14.502v13.541h-1.921V44.5h1.922zm0-8v5h-1.921v-5h1.922z",
    fill: "#10C98E"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M50.099 38.121h8.678l-11.432 8.834h-8.678l11.432-8.834z",
    stroke: "#376E66",
    strokeWidth: 1.922,
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M56.507 25H66L53.494 35H44l12.507-10z",
    stroke: "#10C98E",
    strokeWidth: 1.922,
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M59.424 37.41a.961.961 0 00-1.295 1.421l1.295-1.42zm7.929 9.832a.96.96 0 101.295-1.42l-1.295 1.42zm-9.224-8.411l9.224 8.411 1.295-1.42-9.224-8.411-1.295 1.42z",
    fill: "#376E66"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M77.385 35.738a.96.96 0 101.23-1.476l-1.23 1.476zm-10.77-11.476a.96.96 0 10-1.23 1.476l1.23-1.476zm-1.23 1.476l12 10 1.23-1.476-12-10-1.23 1.476z",
    fill: "#10C98E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    stroke: "#376E66",
    strokeWidth: 1.922,
    strokeLinejoin: "round",
    d: "M56.232 47.152h4.515v6.021h-4.515z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M67 42h2v-6h-6v2",
    stroke: "#10C98E",
    strokeWidth: 1.922,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M16.078 35.612a1 1 0 001.844.776l-1.844-.776zm33.505-10.083a1 1 0 10.834-1.818l-.834 1.818zM17.922 36.388c4.567-10.85 17.795-17.216 31.661-10.859l.834-1.818c-14.876-6.82-29.326-.008-34.339 11.901l1.844.776z",
    fill: "#376E66"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 22,
    r: 10,
    fill: "#FFF7EE",
    stroke: "#7E776E",
    strokeWidth: 1.922,
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M28.203 24.883a.96.96 0 10-.625 1.818l.625-1.818zm1.52 1.221l.006-.96h-.005v.96zm2.168-1.524l.947.163-.947-.163zm-.648-1.76l.613-.74-.002-.002-.611.742zm-1.793-.566l-.18.944.007.001.173-.945zm-1.402-.691l-.741.61.004.006.737-.616zm-.412-1.52l-.947-.163v.006l.947.157zm2.168-1.524l-.003.96.003-.96zm1.499 1.213a.96.96 0 10.668-1.802l-.668 1.802zm-3.413 6.06l-.312.909h.002l.005.002a2.1 2.1 0 01.012.004l.04.013c.034.011.08.026.138.043.115.034.277.078.47.122.38.086.915.18 1.478.18l.001-1.922c-.366 0-.747-.063-1.052-.132a5.918 5.918 0 01-.448-.12l-.02-.007-.003-.001h.001l-.312.909zm1.828 1.273a3.552 3.552 0 001.877-.525c.585-.367 1.1-.964 1.243-1.797l-1.894-.327c-.032.185-.144.354-.37.496-.239.15-.554.233-.845.232l-.01 1.921zm3.12-2.322a2.846 2.846 0 00-.982-2.663l-1.227 1.48c.245.203.37.538.315.856l1.894.327zm-.984-2.665c-.404-.333-.855-.492-1.236-.586-.34-.084-.775-.143-.995-.183l-.346 1.89c.39.072.604.09.882.16.239.058.379.125.473.203l1.222-1.484zm-2.223-.768c-.477-.091-.716-.21-.846-.364l-1.474 1.233c.578.692 1.392.91 1.958 1.019l.362-1.888zm-.841-.359a.966.966 0 01-.206-.75l-1.896-.315c-.135.811.1 1.659.619 2.288l1.483-1.223zm-.207-.744c.049-.28.16-.424.297-.518.16-.11.446-.211.92-.21l.007-1.921c-.727-.003-1.437.149-2.017.548-.602.415-.973 1.035-1.1 1.774l1.893.327zm1.218-.727a4.906 4.906 0 011.487.247l.017.006h0-.002l.334-.902.334-.901h-.001l-.002-.001a.178.178 0 00-.005-.002l-.012-.005-.04-.014a6.789 6.789 0 00-.597-.168 6.816 6.816 0 00-1.507-.182L29.8 19.48z",
    fill: "#7E776E"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M29.956 26.732l.001 1.693M29.973 16.106l-.004 1.649",
    stroke: "#7E776E",
    strokeWidth: 1.922,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgBridgingLoan;